import { render, staticRenderFns } from "./WideVine.vue?vue&type=template&id=627a2178&"
import script from "./WideVine.vue?vue&type=script&lang=js&"
export * from "./WideVine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports